"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SoundBlocksExecutor = exports.LookBlocksExecutor = exports.EventBlocksExecutor = void 0;
exports.getConnectedCog = getConnectedCog;
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _raft = require("@robotical/webapp-types/dist-types/src/types/raft");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * A class responsible for executing the blocks of the slot machine.
 * Communicates with Cog and also manages the isExecuting state of each wheel.
 */
class Executor {
  // if the slot machine should execute the next wheel

  constructor(wheels, wheelsFrontPoster, setters) {
    _defineProperty(this, "shouldExecute", true);
    this.wheels = wheels;
    this.wheelsFrontPoster = wheelsFrontPoster;
    this.setters = setters;
  }
  async execute() {
    var _window$applicationMa, _window$applicationMa2;
    this.setters.setIsExecuting(true);
    this.shouldExecute = true;
    const reorderedWheelFrontPosters = this.wheelsFrontPoster.sort((a, b) => a.idx - b.idx);
    for (const {
      idx,
      item
    } of reorderedWheelFrontPosters) {
      if (!this.shouldExecute) {
        break;
      }
      await this.executeWheel(idx);
    }
    // turn off led after execution
    const connectedCog = getConnectedCog();
    if (connectedCog) {
      await connectedCog.sendRestMessage('led/ring/color/000000');
    }
    (_window$applicationMa = window.applicationManager.carouselNavigatorManager.getNavigator("games")) === null || _window$applicationMa === void 0 || _window$applicationMa.setIsVisible(true);
    (_window$applicationMa2 = window.applicationManager.carouselNavigatorManager.getNavigator("games")) === null || _window$applicationMa2 === void 0 || _window$applicationMa2.setHighlightedItem("/jumping-game");
    this.setters.setIsExecuting(false);
  }
  async executeWheel(idx) {
    this.updateExecutingStateOfWheel(idx, true);
    const frontPosterOfWheel = this.wheelsFrontPoster.find(i => i.idx === idx);
    if (!frontPosterOfWheel) {
      return false;
    }
    const executionPromiseForWheel = await frontPosterOfWheel.item.execute();
    this.updateExecutingStateOfWheel(idx, false);
    return executionPromiseForWheel;
  }
  async stop() {
    this.shouldExecute = false;
    this.setters.setIsExecuting(false);
    this.wheels.forEach((_, idx) => {
      this.updateExecutingStateOfWheel(idx, false);
    });
  }
  updateExecutingStateOfWheel(idx, isExecuting) {
    this.setters.setWheels(this.wheels.map((wheel, index) => {
      if (index === idx) {
        return _objectSpread(_objectSpread({}, wheel), {}, {
          isExecuting
        });
      }
      return wheel;
    }));
  }
}
exports.default = Executor;
function getConnectedCog() {
  var _window$applicationMa3;
  const connectedCog = (_window$applicationMa3 = window.applicationManager) === null || _window$applicationMa3 === void 0 ? void 0 : _window$applicationMa3.getTheCurrentlySelectedDeviceOrFirstOfItsKind(_raft.RaftTypeE.COG);
  return connectedCog;
}
class EventBlocksExecutor {
  static async onTiltAny() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    const dataAnalyser = connectedCog.publishedDataAnalyser;

    // check every 200ms if the cog has tilted left
    const tiltLeftPromise = new Promise(resolve => {
      const interval = setInterval(() => {
        if (dataAnalyser.cogState.tilt === 'left' || dataAnalyser.cogState.tilt === 'right' || dataAnalyser.cogState.tilt === 'forward' || dataAnalyser.cogState.tilt === 'backward') {
          clearInterval(interval);
          resolve(true);
        }
      }, 200);
    });
    return tiltLeftPromise;
  }
  static async onShake() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    const dataAnalyser = connectedCog.publishedDataAnalyser;

    // check every 200ms if the cog has tilted left
    const shakePromise = new Promise(resolve => {
      const interval = setInterval(() => {
        if (dataAnalyser.cogState.movementType === 'shake') {
          clearInterval(interval);
          resolve(true);
        }
      }, 200);
    });
    return shakePromise;
  }
  static async onTiltLeft() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    const dataAnalyser = connectedCog.publishedDataAnalyser;

    // check every 200ms if the cog has tilted left
    const tiltLeftPromise = new Promise(resolve => {
      const interval = setInterval(() => {
        if (dataAnalyser.cogState.tilt === 'left') {
          clearInterval(interval);
          resolve(true);
        }
      }, 200);
    });
    return tiltLeftPromise;
  }
  static async onTiltRight() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    const dataAnalyser = connectedCog.publishedDataAnalyser;

    // check every 200ms if the cog has tilted right
    const tiltRightPromise = new Promise(resolve => {
      const interval = setInterval(() => {
        if (dataAnalyser.cogState.tilt === 'right') {
          clearInterval(interval);
          resolve(true);
        }
      }, 200);
    });
    return tiltRightPromise;
  }
  static async onTiltBackwards() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    const dataAnalyser = connectedCog.publishedDataAnalyser;

    // check every 200ms if the cog has tilted backwards
    const tiltBackwardsPromise = new Promise(resolve => {
      const interval = setInterval(() => {
        if (dataAnalyser.cogState.tilt === 'backward') {
          clearInterval(interval);
          resolve(true);
        }
      }, 200);
    });
    return tiltBackwardsPromise;
  }
  static async onTiltForwards() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    const dataAnalyser = connectedCog.publishedDataAnalyser;

    // check every 200ms if the cog has tilted forwards
    const tiltForwardsPromise = new Promise(resolve => {
      const interval = setInterval(() => {
        if (dataAnalyser.cogState.tilt === 'forward') {
          clearInterval(interval);
          resolve(true);
        }
      }, 200);
    });
    return tiltForwardsPromise;
  }
  static async onTouchCog() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    const dataAnalyser = connectedCog.publishedDataAnalyser;

    // check every 200ms if the cog has been touched
    const touchCogPromise = new Promise(resolve => {
      const interval = setInterval(() => {
        if (dataAnalyser.cogState.buttonClick === 'click') {
          clearInterval(interval);
          console.log("resolved");
          resolve(true);
        }
      }, 200);
    });
    return touchCogPromise;
  }
}
exports.EventBlocksExecutor = EventBlocksExecutor;
class LookBlocksExecutor {
  static async setColorLED(color) {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }

    // set the color of the LED
    await connectedCog.sendRestMessage("led/ring/color/".concat(color));
    await wait(2000);
    return true;
  }
  static async patternRainbow() {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }

    // set the color of the LED
    await connectedCog.sendRestMessage('led/ring/pattern/RainbowSnake');
    await wait(2000);
    return true;
  }
}
exports.LookBlocksExecutor = LookBlocksExecutor;
class SoundBlocksExecutor {
  static async playSound(sound) {
    const connectedCog = getConnectedCog();
    if (!connectedCog) {
      return false;
    }
    let soundDuration = 0;
    switch (sound) {
      case "disbelief":
        soundDuration = 6000;
        await connectedCog.sendRestMessage('audio/rtttl/Disbelief:d=4,o=5,b=120:g,8d#,8e,8f,8f#,8g,8a,8b,8c6,8p,8c6,8b,8a,8g,8f#,8e,8f,8d#,8p,8g');
        break;
      case "confusion":
        soundDuration = 10000;
        await connectedCog.sendRestMessage('audio/rtttl/Confused:d=4,o=5,b=120:c,e,g,c6,e6,g6,c,e,g,c6,e6,g6,c,e,g,a,a,b,b,c6');
        break;
      case "excitement":
        soundDuration = 5000;
        await connectedCog.sendRestMessage('audio/rtttl/Excitement:d=4,o=5,b=180:c,e,g,8c6,16p,8c6,16p,8c6,16p,c,e,g,8c6,16p,8c6,16p,8c6,16p,c,e,g,8c6');
        break;
      case "noway":
        soundDuration = 6000;
        await connectedCog.sendRestMessage('audio/rtttl/NoWay:d=4,o=5,b=120:p,8g,8p,8c6,8p,8g,8p,8a,8p,8f,8p,8e,8p,8d,8p,8c,8p,8g,8p,8c6,8p,8g');
        break;
      case "no":
        soundDuration = 3000;
        await connectedCog.sendRestMessage('audio/rtttl/No:d=4,o=5,b=100:p,8c,8p,8c,8p,8c,8p,8c');
        break;
      case "whistle":
        soundDuration = 3000;
        await connectedCog.sendRestMessage('audio/rtttl/Whistle:d=4,o=6,b=140:16b5,16p,16b5,16p,16b5,16p,16g,16p,16e,16p,16g,16p,16c7,16p,16c7,16p,16c7,16p,16a,16p,16f,16p,16a,16p,16d7');
        break;
      default:
        break;
    }
    await wait(soundDuration);
    return true;
  }
}
exports.SoundBlocksExecutor = SoundBlocksExecutor;
const wait = ms => new Promise(resolve => setTimeout(resolve, ms));